const state = {
  windowWidth: window.innerWidth,
};

const actions = {
  setWindowWidth(context) {
    context.commit("setWindowWidth");
  },
};

const mutations = {
  setWindowWidth(state) {
    state.windowWidth = window.innerWidth;
  },
};

export const device = {
  namespaced: true,
  state,
  actions,
  mutations,
};
